import { UpsellItemsConfiguration, UpsellModalComponentType } from '@app-types/eligibility/config';

import { PLAY } from '@constants/provider';

const downgradePlayUpsell: UpsellItemsConfiguration[] = (() => {
    return ['standard', 'gaming', 'tablette', 'serie_speciale'].flatMap((commercialSeries) => {
        return [
            {
                baseProduct: { rangeNg: 'must', commercialSeries, play: PLAY._3P },
                upselledProduct: { rangeNg: 'must', commercialSeries, play: PLAY._2P },
                modalComponentType: UpsellModalComponentType.DOWNGRADE_MUST_PLAY,
            },
            {
                baseProduct: { rangeNg: 'ultym', commercialSeries, play: PLAY._3P },
                upselledProduct: { rangeNg: 'ultym', commercialSeries, play: PLAY._2P },
                modalComponentType: UpsellModalComponentType.DOWNGRADE_ULTYM_PLAY,
            },
        ];
    });
})();

export const globalFaiUpsellConfig: UpsellItemsConfiguration[] = [
    ...downgradePlayUpsell,
    {
        baseProduct: { rangeNg: 'must', commercialSeries: 'serie_client_bandyou', play: PLAY._3P },
        upselledProduct: { rangeNg: 'must', commercialSeries: 'serie_client_bandyou', play: PLAY._2P },
        modalComponentType: UpsellModalComponentType.BYOU,
    },
];
